// extracted by mini-css-extract-plugin
export default {"buttonDone":"AlignActionButton_buttonDone__FOkYS"};